import React from "react";

export const GeneratingFeedbackIcon = () => (
  <svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
    <circle cx="200" cy="200" r="150" fill="#E8E8EC" opacity="0.6" />

    <circle cx="80" cy="130" r="18" fill="#C5C5D0" opacity="0.4">
      <animate
        attributeName="cy"
        values="130;120;130"
        dur="3s"
        repeatCount="indefinite"
      />
    </circle>
    <circle cx="340" cy="180" r="22" fill="#C5C5D0" opacity="0.3">
      <animate
        attributeName="cy"
        values="180;170;180"
        dur="2.5s"
        repeatCount="indefinite"
        begin="0.5s"
      />
    </circle>
    <circle cx="100" cy="320" r="20" fill="#C5C5D0" opacity="0.35">
      <animate
        attributeName="cy"
        values="320;310;320"
        dur="2.8s"
        repeatCount="indefinite"
        begin="0.3s"
      />
    </circle>
    <circle cx="320" cy="300" r="16" fill="#C5C5D0" opacity="0.4">
      <animate
        attributeName="cy"
        values="300;290;300"
        dur="3.2s"
        repeatCount="indefinite"
        begin="0.7s"
      />
    </circle>

    <g transform="translate(200, 180)">
      <g filter="url(#shadow)">
        <path
          d="M -50,-70 L -50,40 Q -50,50 -40,50 L 40,50 Q 50,50 50,40 L 50,-40 L 20,-70 Z"
          fill="#F5F5F7"
          stroke="#9B9BA5"
          strokeWidth="3"
          strokeLinejoin="round"
        />

        <path
          d="M 20,-70 L 20,-40 L 50,-40"
          fill="#E0E0E5"
          stroke="#9B9BA5"
          strokeWidth="3"
          strokeLinejoin="round"
        />
      </g>

      <g>
        <path
          d="M -20,-10 Q -15,-15 -10,-10"
          fill="none"
          stroke="#9B9BA5"
          strokeWidth="4"
          strokeLinecap="round"
        />

        <path
          d="M 10,-10 Q 15,-15 20,-10"
          fill="none"
          stroke="#9B9BA5"
          strokeWidth="4"
          strokeLinecap="round"
        />

        <circle
          cx="0"
          cy="10"
          r="6"
          fill="none"
          stroke="#9B9BA5"
          strokeWidth="3"
        />
      </g>

      <g opacity="0.7">
        <circle cx="-25" cy="-85" r="4" fill="#9B9BA5">
          <animate
            attributeName="opacity"
            values="0;1;0"
            dur="2s"
            repeatCount="indefinite"
            begin="0s"
          />
        </circle>
        <circle cx="-10" cy="-95" r="5" fill="#9B9BA5">
          <animate
            attributeName="opacity"
            values="0;1;0"
            dur="2s"
            repeatCount="indefinite"
            begin="0.3s"
          />
        </circle>
        <circle cx="8" cy="-100" r="6" fill="#9B9BA5">
          <animate
            attributeName="opacity"
            values="0;1;0"
            dur="2s"
            repeatCount="indefinite"
            begin="0.6s"
          />
        </circle>
      </g>
    </g>

    <g transform="translate(200, 280)">
      <circle cx="0" cy="0" r="35" fill="#01ECFF" opacity="0.8" />
      <circle
        cx="0"
        cy="0"
        r="28"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="3"
        strokeDasharray="44 132"
        strokeLinecap="round"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 0 0"
          to="360 0 0"
          dur="1.5s"
          repeatCount="indefinite"
        />
      </circle>
    </g>

    <defs>
      <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="3" />
        <feOffset dx="0" dy="4" result="offsetblur" />
        <feComponentTransfer>
          <feFuncA type="linear" slope="0.2" />
        </feComponentTransfer>
        <feMerge>
          <feMergeNode />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
  </svg>
);
